import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../../shared';
import { EndpointContainerModel } from '../../../../../../../models/aggregates/alg/cc/endpoint';

@Injectable({ providedIn: 'root' })
export class EndpointService extends BaseApiTemplateService<EndpointContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_TEST_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'endpoints';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'endpoints';
    this.httpClient = http;
  }
}
